export default __webpack_public_path__ + "static/media/7.baa6a159.png";